import React from 'react';
import ReactDOM from 'react-dom';

import './bootstrap';

import Select from 'react-select';
import UserTable from './containers/UserTableContainer';
import TagInput from './containers/TagInputContainer';
import PlayerDashboard from './containers/PlayerDashboard';
import PlayerStats from './containers/PlayerStats';
import HeroHeader from './containers/HeroHeader';

// window.moment = moment;

window.Components = {
  UserTable,
  TagInput,
  PlayerDashboard,
  PlayerStats,
  Select,
  HeroHeader,
};

if (window.renderQueue) {
  window.renderQueue.forEach(fn => fn(React, ReactDOM, window.Components));
}
